export default __webpack_public_path__ + "static/media/LinkedinIcon.b97873c1.svg";